export const SET_TECH = "SET_TECH";







